import connection from './connection'
import config from 'config'

connection.create()

if(config.api && config.api.mock === true) {
  connection.mock()
}


// WEBPACK FOOTER //
// ./src/api/config/configure.js